import { render, staticRenderFns } from "./SchoolSemester.vue?vue&type=template&id=1cdc8db7"
import script from "./SchoolSemester.vue?vue&type=script&lang=js"
export * from "./SchoolSemester.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports